import { EditorThemeClasses } from 'lexical'

export const editorTheme: EditorThemeClasses = {
  heading: {
    h1: 'text-2xl font-bold',
    h2: 'text-xl font-medium',
  },
  link: 'text-primary underline cursor-pointer',
  paragraph: 'text-wrap',
  list: {
    ul: 'list-disc list-outside pl-4',
    ol: 'list-decimal list-outside pl-4',
  },
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
  },
}
